/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fac_Menu_ItemInputs */

const en_fac_menu_item = /** @type {(inputs: Fac_Menu_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Facilitator`)
};

const id_fac_menu_item = /** @type {(inputs: Fac_Menu_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fasilitator`)
};

/**
* | output |
* | --- |
* | "Facilitator" |
*
* @param {Fac_Menu_ItemInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const fac_menu_item = /** @type {((inputs?: Fac_Menu_ItemInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fac_Menu_ItemInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_fac_menu_item(inputs)
	return en_fac_menu_item(inputs)
});